/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-underscore-dangle */

'use-strict';

import { ISCEService, IScope } from 'angular';

import { FileInput } from '../../../src/app/@types';
import { EFileSection, EStaticFileType, StaticUploadRequest } from '../../../src/app/@shared-types/misc/file';

import { SalesAPIService } from '../../../shared/api/sales-api.service';
import { NumberConversionService } from '../../../shared/converter/number-converter.service';
import { FileService, FileServiceUploadRequest } from '../../../shared/storage/file.service';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { ConfigService } from '../../../shared/config/config.service';
import { EInventoryState } from '../../../src/app/@shared-types/vehicle/enums';
import { DeepPartial } from '../../../src/app/@shared-types';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';

interface PanoramicScope extends IScope {
  sending: boolean,
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  formTransmission: () => void,
  deleteImage: () => void,
  vehicle: AutoboardVehicle,
  panoramicData: {
    panoramic?: FileInput,
    currentUrl?: string,
  },
}

/* @ngInject */
export default function DeliverPanoramicFormController(
  $scope: PanoramicScope,
  fileService: FileService,
  salesApiService: SalesAPIService,
  toastService: ToastService,
  $sce: ISCEService,
): void {
  $scope.sending = false;

  $scope.panoramicData = {};

  if ($scope.vehicle.vehicleData.panoramicImage) {
    $scope.panoramicData.currentUrl = $sce.trustAsResourceUrl(`https://cdn.pannellum.org/2.5/pannellum.htm#panorama=${fileService.getStaticUrl($scope.vehicle.vehicleData.panoramicImage)}&autoLoad=true`);
  }

  $scope.exitForm = () => $scope.exit({ removeLock: true });

  const updatePanoramicImage = async (image?: string): Promise<void> => {
    const changedVals: DeepPartial<AutoboardVehicle> = {
      _id: $scope.vehicle._id,
      vehicleData: {
        panoramicImage: image,
      },
    };

    await salesApiService.putVehicle(changedVals);
  };

  $scope.deleteImage = async () => {
    const staticId = $scope.vehicle.vehicleData.panoramicImage;
    if (!staticId) return;

    await updatePanoramicImage('');
    await fileService.deleteStatic(staticId);

    $scope.exit({});
    toastService.toast(ToastType.SUCCESS, 'Panaromabild wurde gelöscht.');
  };

  $scope.formTransmission = async () => {
    $scope.sending = true;

    if (!$scope.panoramicData.panoramic?.file) return;

    const { panoramic } = $scope.panoramicData;
    const uploadReq: StaticUploadRequest = {
      identifier: String($scope.vehicle._id),
      type: EStaticFileType.PANORAMIC_IMAGE,
    };

    const panoramicStaticId = await fileService
      .apiUploadStatic(panoramic.file, uploadReq, panoramic.progressBar);

    await updatePanoramicImage(panoramicStaticId);

    $scope.exit({});
  };
}
